import { createFromJS } from "../../../types";
import { actionTypes } from "./actions";

const reducer = (state = createFromJS.SubwayViewSettingsRecord({}), action) => {
  switch (action.type) {
    case actionTypes.CHANGE_DISPLAY:
      return state.set("display", action.display);
    case actionTypes.CHANGE_TEXT_LINES:
      return state.set("numTextLines", action.numTextLines);
    default:
      return state;
  }
};

export default reducer;
